<template>
  <div>
    <el-dialog
      v-if="visible"
      :title="title"
      :visible="visible"
      width="1000px"
      top="10vh"
      show-close
      :close-on-click-modal="false"
      append-to-body
      :before-close="() => close()"
    >
      <DetailForm ref="detailForm" :orderMaterialCode="orderMaterialCode" />
      <span slot="footer">
        <el-button size="small" @click="close()">
          {{ $l('INDEX.btn_close') || '关闭' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import DetailForm from './index.vue'
export default {
  components: { DetailForm },
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    orderMaterialCode: { type: String, default: '' },
  },
  methods: {
    close() {
      this.$emit('close')
      this.$emit('update:visible', false)
    },
  },
}
</script>
